import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollData, summaryData, payrollStatementData, absentDeductionPayHeadPayHead = []) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            pageOrientation: 'landscape',
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollStatementData, absentDeductionPayHeadPayHead),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 7,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Payroll',
            }
        }

        pushIntoTable(doc, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollData, summaryData, absentDeductionPayHeadPayHead)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollStatementData, absentDeductionPayHeadPayHead) => {
        return [
            {
                text:  'Payroll' + '(' + payrollStatementData.payroll_start_date + ' to ' + payrollStatementData.payroll_end_date + ')',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: getTableWidth(grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, absentDeductionPayHeadPayHead)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const pushIntoTable = (doc, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, payrollData, summaryData, absentDeductionPayHeadPayHead) => {
        const tableItems = payrollData;
        const tableHeader = getTableHeader(grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, absentDeductionPayHeadPayHead);
        doc.content[1].table.body.push(tableHeader);

        tableItems.forEach((item) => {
            const rowData = getRowData(item, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, absentDeductionPayHeadPayHead);
            return doc.content[1].table.body.push(rowData);
        });

        const getLastRow = getTotal(summaryData, grossComponentPayHead, otherEarningPayHead, deductionPayHeadPayHead, absentDeductionPayHeadPayHead)
        doc.content[1].table.body.push(getLastRow);
    }

    const getTableWidth = (grossComponentPayHead = [], otherEarningPayHead = [], deductionPayHeadPayHead = [], absentDeductionPayHeadPayHead = []) => {
        let dynamicColumns =
            grossComponentPayHead.length + 1 +
            otherEarningPayHead.length + 1 +
            deductionPayHeadPayHead.length + 2;

        if (absentDeductionPayHeadPayHead.length > 0){
            dynamicColumns += absentDeductionPayHeadPayHead.length + 2
        }

        const width = ['10%', '10%'];
        const remainingPercentage = 80;
        const individualWidth = (remainingPercentage / dynamicColumns) + '%';

        for (let i = 0; i < dynamicColumns; i++) {
            width.push(individualWidth);
        }

        return width;
    };

    const getTableHeader = (grossComponentPayHead = [], otherEarningPayHead = [], deductionPayHeadPayHead = [], absentDeductionPayHeadPayHead = []) => {
        const tableHeader = [
            { text: 'Employee ID' },
            { text: 'Employee Name' },
            ...grossComponentPayHead.map(item => ({ text: item.name })),
            { text: 'Gross Salary' },
        ];

        if (absentDeductionPayHeadPayHead.length > 0) {
            tableHeader.push(
                ...absentDeductionPayHeadPayHead.map(item => ({ text: item.name })),
                { text: 'Gross Salary after Attendance Deduction' }
            );
        }

        tableHeader.push(
            ...otherEarningPayHead.map(item => ({ text: item.name })),
            { text: 'Total Earning' },
            ...deductionPayHeadPayHead.map(item => ({ text: item.name })),
            { text: 'Total Deduction' },
            { text: 'Net' },
        );

        if (absentDeductionPayHeadPayHead.length > 0) {
            tableHeader.push(
                { text: 'Attendance Remarks' },
            );
        }

        return tableHeader;
    };

    const getRowData = (
        item = {},
        grossComponentPayHead = [],
        otherEarningPayHead = [],
        deductionPayHeadPayHead = [],
        absentDeductionPayHeadPayHead = []
    ) => {

        const tableRow = [
            { text: item.serial_no },
            { text: item.name },

            ...grossComponentPayHead.map(gh => ({
                text: commaFormat(item.gross_earnings[gh.id] || 0),
                alignment: 'right'
            })),

            { text: commaFormat(item.gross || 0), alignment: 'right' },
        ];

        if (absentDeductionPayHeadPayHead.length > 0) {
            tableRow.push(
                ...absentDeductionPayHeadPayHead.map(ah => ({
                    text: commaFormat(item.absent_deductions[ah.id] || 0),
                    alignment: 'right'
                }))
            );

            tableRow.push({
                text: commaFormat(item.total_earning_after_absent_deduction || 0),
                alignment: 'right'
            });
        }

        tableRow.push(
            ...otherEarningPayHead.map(oh => ({
                text: commaFormat(item.other_earnings[oh.id] || 0),
                alignment: 'right'
            }))
        );

        tableRow.push({
            text: commaFormat(item.total_earning || 0),
            alignment: 'right'
        });

        tableRow.push(
            ...deductionPayHeadPayHead.map(dh => ({
                text: commaFormat(item.deductions[dh.id] || 0),
                alignment: 'right'
            }))
        );

        tableRow.push({
            text: commaFormat(item.total_deduction || 0),
            alignment: 'right'
        });

        tableRow.push({
            text: commaFormat(item.total || 0),
            alignment: 'right'
        });

        if (absentDeductionPayHeadPayHead.length > 0) {
            let remarksText = '';
            if (item.note && typeof item.note === 'object') {
                 remarksText = Object.entries(item.note)
                    .filter(([_, value]) => value > 0)
                    .map(([key, value]) => `${formatKey(key)}: ${value}`)
                    .join('  ');
            }
            tableRow.push({ text: remarksText });
        }

        return tableRow;
    };

    const formatKey = (key) => {
        if (typeof key !== 'string') key = String(key);
        return key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
    }

    const getTotal = (
        summaryData = {},
        grossComponentPayHead = [],
        otherEarningPayHead = [],
        deductionPayHeadPayHead = [],
        absentDeductionPayHeadPayHead = []
    ) => {
        const tableRow = [
            { text: "Total", colSpan: 2 },
            '',
            ...grossComponentPayHead.map(gh => ({
                text: commaFormat(summaryData.gross_earnings[gh.id] || 0),
                alignment: 'right'
            })),
            { text: commaFormat(summaryData.total_gross || 0), alignment: 'right' },
        ];

        if (absentDeductionPayHeadPayHead.length > 0) {
            tableRow.push(
                ...absentDeductionPayHeadPayHead.map(ah => ({
                    text: commaFormat(summaryData.absent_deductions[ah.id] || 0),
                    alignment: 'right'
                }))
            );

            tableRow.push({
                text: commaFormat(summaryData.total_earning_after_absent_deduction || 0),
                alignment: 'right'
            });
        }

        tableRow.push(
            ...otherEarningPayHead.map(oh => ({
                text: commaFormat(summaryData.other_earnings[oh.id] || 0),
                alignment: 'right'
            }))
        );

        tableRow.push({
            text: commaFormat(summaryData.total_earning || 0),
            alignment: 'right'
        });

        tableRow.push(
            ...deductionPayHeadPayHead.map(dh => ({
                text: commaFormat(summaryData.deductions[dh.id] || 0),
                alignment: 'right'
            }))
        );

        tableRow.push({
            text: commaFormat(summaryData.total_deduction || 0),
            alignment: 'right'
        });

        tableRow.push({
            text: commaFormat(summaryData.total_net_payable || 0),
            alignment: 'right'
        });

        if (absentDeductionPayHeadPayHead.length > 0) {
            tableRow.push({
                text: ''
            });
        }

        return tableRow;
    };

    return {
        exportToPDF
    }

}

export default pdfPrinter;